// extracted by css-extract-rspack-plugin
module.exports =  {"resultlWidgetWrapper":"IFCPV","source":"DItMD","cs":"_EFci","cl":"D5F70","noteText":"Owvtr","vsBox":"QX6M8"};